import styles from './SuggestionPickerField.module.scss';

import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import clsx from 'clsx';
import React, { useRef } from 'react';

import { Caption } from '@work4all/components/lib/typography/caption/Caption';

import { reactRefSetter } from '@work4all/utils';

import { Autocomplete } from '../../containers/mask-overlays/locked-inputs';

export interface SuggestionPickerFieldProps {
  error?: string;
  label?: string;
  onChange: (e) => void;
  value: string;
  data: string[];
}

const CssTextField = styled(TextField)({
  '& .MuiFilledInput-root': {
    paddingTop: '1rem',
    paddingBottom: '0.25rem !important',
    borderRadius: '0.25rem',
    paddingLeft: '0.25rem',
    backgroundColor: 'var(--ui02)',
    border: '1px solid var(--ui04)',
  },
  '& .MuiFilledInput-root:before, .MuiFilledInput-root:after': {
    display: 'none',
  },
  '& .MuiInputLabel-root': {
    transform: 'translate(7px, 11px) scale(1)',
  },
  '& .Mui-focused.MuiInputLabel-root, .MuiFormLabel-filled.MuiInputLabel-root':
    {
      transform: 'translate(7px, 4px) scale(0.75)',
      fontSize: '0.85rem',
      fontWeight: '500',
    },
});

export const SuggestionPickerField = React.forwardRef<
  HTMLDivElement,
  SuggestionPickerFieldProps
>(function SuggestionPickerField(props, ref) {
  const { label, onChange, ...pickerProps } = props;
  const { value = '', error } = pickerProps;

  const wrapperRef = useRef<HTMLDivElement>(null);

  const { data } = props;

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <Autocomplete
        freeSolo
        ListboxProps={{ style: { maxHeight: '10rem' } }}
        getOptionLabel={(option) => option}
        options={data}
        onInputChange={(e, value) => {
          onChange(value);
        }}
        value={value}
        renderInput={(params) => (
          <div
            className={clsx(styles.wrapper, {
              [styles.error]: error !== undefined,
            })}
          >
            <CssTextField
              {...params}
              label={label}
              variant="filled"
              size="small"
            />
            {error !== undefined && (
              <div className={styles.errorMessage}>
                <Caption color="error">{error}</Caption>
              </div>
            )}
          </div>
        )}
        onChange={(e, value) => {
          onChange(value ?? '');
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option} style={{ textAlign: 'left' }}>
              <div>{option}</div>
            </li>
          );
        }}
      />
    </div>
  );
});
